import HomeTemplate from "../../Templates/Home";

const HomePage = () => {
  return (
    <>
      <HomeTemplate />
    </>
  );
};

export default HomePage;
